import { useState } from "react";
import { Input } from "@/components/ui/input";

type FormattedNumberInputProps = {
  value: number | null;
  onChange: (value: number | null) => void;
} & React.ComponentProps<"input">;

export function FormattedNumberInput({
  value,
  onChange,
  ...props
}: FormattedNumberInputProps) {
  const [display, setDisplay] = useState(
    value != null ? value.toLocaleString() : ""
  );

  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const raw = e.target.value.replace(/[^\d.]/g, ""); // remove commas and non-numbers

    const num = parseFloat(raw);
    if (!isNaN(num)) {
      const formatted = num.toLocaleString();
      setDisplay(formatted);
      onChange(num);
    } else {
      setDisplay("");
      onChange(null);
    }
  };

  const handleBlur = () => {
    if (value != null) {
      setDisplay(value.toLocaleString());
    }
  };

  const handleFocus = () => {
    if (value != null) {
      setDisplay(value.toString());
    }
  };

  return (
    <Input
      {...props}
      type="text"
      value={display}
      onChange={handleChange}
      onBlur={handleBlur}
      onFocus={handleFocus}
      inputMode="numeric"
    />
  );
}
